export default (theme, gap) => ({
  defaultProps: {
    gap,
  },
});
